import Title_JobStatusList from "@/components/SingleUse/ComponentOverrides/pagetitle/Title_JobStatusList.vue";
import RouteListItem_JobList from "@/components/SingleUse/ComponentOverrides/sidebar/RouteListItem_JobList.vue";
import AccessMatrix from '@/router/access-matrix';

const RouterView = () => import('@/views/landingpages/RouterView.vue')
const JobList = () => import('@/views/job/AdminJobList.vue')
const NewJob = () => import('@/views/job/newjob/NewJob.vue')
const NewJobStart = () => import('@/views/job/newjob/NewJobStart.vue')
const NewJobOverview = () => import('@/views/job/newjob/NewJobOverview.vue')

import viewJobBranch from '@/router/mt-job-view-branch.js';

//Export item
const trunk = {
  meta: {
    authorize: AccessMatrix.JobsTrunk.module,
    display: { key: "servicesystem.pages.page_titles.job" },
    icon: "$job",
  },
  name: "Job",
  path: "/job",
  component: RouterView,
  redirect: { name: "JobList", params: { filter: "my" } },
  children: [  
    {
      meta: {
        authorize: AccessMatrix.JobsTrunk.module,
        overrides: {
          header: {
            buttons: ['NewJobBtn'],
          },
          title: Title_JobStatusList,
          sidebar: RouteListItem_JobList,
        }
      },
      path: "list/:filter",
      name: "JobList",
      component: JobList,
      children: [
         {
          meta: {
            authorize: AccessMatrix.JobsTrunk.newjob_branch,
            display: { key: "servicesystem.pages.page_titles.job_new_job" },
            icon: "mdi-briefcase-plus",
            overrides: {
              sidebar: false,
            },
            contextMenu: 'Hidden',
          },
          path: 'newjob',
          name: 'NewJob',
          component: NewJob,
          redirect: { name: 'NewJobStart' },
          children: [
            {
              meta: {
                authorize: AccessMatrix.JobsTrunk.newjob_branch,
                display: { key: "servicesystem.pages.page_titles.job_new_job_start" },
                icon: "mdi-format-list-checks",
                overrides: {
                  header: {
                    buttons: ['CancelNewJobBtn'],
                  },
                }
              },
              path: "start/:jobId?",
              name: "NewJobStart",
              component: NewJobStart
            },

            {
              meta: {
                authorize: AccessMatrix.JobsTrunk.newjob_branch,
                display: { key: "servicesystem.pages.page_titles.job_new_job_set_details" },
                icon: "mdi-briefcase-edit",
                overrides: {
                  header: {
                    buttons: ['CancelNewJobBtn', 'CreateJobBtn'],
                  },
                }
              },
              path: "overview",
              name: "NewJobOverview",
              component: NewJobOverview
            },
          ]
        },  
        
        viewJobBranch,

      ]
    },
  ],
};

export default trunk;
